import { Encoding } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export type Union =
  | ReturnType<typeof importDatasetSuccess>
  | ReturnType<typeof importDatasetFailure>
  | ReturnType<typeof clearImportDatasetResponse>
  | ReturnType<typeof selectQuery>
  | ReturnType<typeof selectLegacyTable>
  | ReturnType<typeof updateReportLayout>;

export const importDatasetSuccess = createAction(
  '[ReportEditor] Import Dataset Success',
  props<{ accountId: string; reportId: string; switchViewToken: string; vizToken: string | undefined }>()
);

export const importDatasetWithChartFromSearch = createAction(
  '[ReportEditor] Import Dataset With Chart From Search',
  props<{
    accountId: string;
    reportId: string;
    queryToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const importDatasetWithChartFromUrl = createAction(
  '[ReportEditor] Import Dataset With Chart From Url',
  props<{
    accountId: string;
    reportId: string;
    queryToken: string;
    chartColorPaletteToken: string;
    encoding: Encoding;
    format: ChartTypes.ChartFormat;
    fieldFormats: ChartTypes.FieldFormatMap;
  }>()
);

export const importDatasetFailure = createAction('[ReportEditor] Import Dataset Failure', props<{ error: string }>());

export const clearImportDatasetResponse = createAction('[ReportEditor] Clear Import Dataset Response');

export const selectQuery = createAction('[ReportEditor] Select Query', props<{ token: string }>());

export const selectLegacyTable = createAction(
  '[ReportEditor] Select Legacy Table',
  props<{ token: string; queryToken: string }>()
);

export const updateReportLayout = createAction('[ReportEditor] Update ReportLayout', props<{ layout: string }>());
